import { Button, Modal, Fade, Backdrop, Box, IconButton } from '@mui/material'
import { isEmpty } from 'lodash'

import { Icons } from '../../components/Icons'
import CloseIcon from '@mui/icons-material/Close'
import iconArrowBack from '../../assets/icons/arrowBack.svg'
import iconClose from '../../assets/icons/close.svg'
import devicePhone from '../../assets/icons/devicePhone.svg'
import playOutline from '../../assets/icons/playOutline.svg'
import deviceTv from '../../assets/icons/deviceTv.svg'
import signal from '../../assets/icons/signal.svg'
import calendar from '../../assets/icons/calendar.svg'
import check from '../../assets/icons/check.svg'
import { logoutKeycloak } from '../../utils/logout'

export default function PlansContainer(props) {
  const {
    email,
    handleOnPayPlan,
    navigate,
    handleOnChangePlan,
    isSameUser,
    plans,
    setIsSameUser,
    subscription: {
      can_change: canChange = false,
      paid = false,
      Plan
    },
    subscriptionsPlanIds,
    userId,
    closeErrorModal,
    reloadPage,
    error,
    preferredPlan,
    isOpenPreferredPlan,
    closePreferredPlanModal
  } = props

  const isCompatible = plan => plan?.incompatible !== true

  const onlySuscriptions = plans.filter(plan => plan?.type === 'SUBSCRIPTION' && plan?.unique_pay !== true && isCompatible(plan))
  const onlyOneTimePlans = plans.filter(plan => plan?.unique_pay === true && isCompatible(plan))
  const filteredPreferredPlan = plans.find(plan => plan?.id === preferredPlan && isCompatible(plan));

  const getIcon = (icon) => {
    switch (icon) {
      case 'devicePhone':
        return devicePhone
      case 'signal':
        return signal
      case 'playOutline':
        return playOutline
      case 'deviceTv':
        return deviceTv
      case 'calendar':
        return calendar
      default:
        return deviceTv
    }
  }

  const renderSubscriptionCard = (plan) => (
    <section
      style={{ display: !plan.show_on_plans ? 'none' : 'inherit' }}
      className={
        (subscriptionsPlanIds.includes(plan.id) && plan.amount !== 0)
          || (!subscriptionsPlanIds.includes(plan.id) && !canChange && paid)
          ? 'active planCard'
          : 'planCard'
      }
      key={plan.id}
    >
      <header>
        <h3>{plan.shortName.toUpperCase()}</h3>
        <div className='planPrice'>
          {plan.amount === 0 ? (
            'Gratis'
          ) : subscriptionsPlanIds.includes(plan.id) ? (
            <>
              <Icons path={check} />
              <p>Adquirido</p>
            </>
          ) : !subscriptionsPlanIds.includes(plan.id) && !canChange && paid ? (
            <>
              <p style={{ color: '#ffff00', fontSize: '0.9rem', textAlign: 'end' }}>No disponible<br />para cambio</p>
            </>
          ) : (
            <>
              {`$${plan.amount.toLocaleString('de')}`}
              <span> {plan.Periodicity?.name?.toLowerCase() || ''}</span>
            </>
          )}
        </div>
      </header>
      <ul>
        {plan.attributes.map((attribute, i) => (
          <li key={i} className={[!attribute.active && 'disabled', attribute.highlighted && 'highlighted'].filter(Boolean).join(' ')}>
            <Icons path={getIcon(attribute.icon)} />
            <div>
              <h5>{attribute.name}</h5>
              <p>{attribute.description}</p>
            </div>
          </li>
        ))}
      </ul>
      <div className='planAction'>
        {!subscriptionsPlanIds.includes(plan.id) && plan.trial_period_days > 0 && !paid
          && <p>{`¡Prueba gratis durante ${plan.trial_period_days} ${plan.trial_period_days === 1 ? 'día' : 'días'}!`}</p>
        }
        {subscriptionsPlanIds.includes(plan.id)
          ? (
            <Button
              onClick={() => navigate('/inicio')}
              type='button'
              variant='contained'
            >
              Ver contenido
            </Button>
          ) : !canChange && paid
            ? (
              <></>
            ) : (
              <Button
                onClick={() => {
                  paid
                    ? handleOnChangePlan({ planId: plan.id })
                    : handleOnPayPlan({ planId: plan.id, isSubscription: true })
                }}
                type='submit'
                variant='contained'
              >
                {
                  ((plan.id === process.env.REACT_APP_MS_PLAN_FULL && subscriptionsPlanIds.includes(process.env.REACT_APP_MS_PLAN_FULL_ANUAL))
                    || Plan.id === process.env.REACT_APP_MS_PLAN_FULL_LEGACY
                    || Plan.id === process.env.REACT_APP_MS_PLAN_FULL_ANUAL_LEGACY)
                    ? `Cambiar a ${plan.shortName}`
                    : (plan.id === process.env.REACT_APP_MS_PLAN_FULL_ANUAL && subscriptionsPlanIds.includes(process.env.REACT_APP_MS_PLAN_FULL))
                      ? '¡Ahorrar 4 meses!'
                      : plan.trial_period_days > 0 ? 'Prueba ahora' : 'Comprar'
                }
              </Button>
            )
        }
      </div>
    </section>
  )

  return (
    <>
      <main className='appWrap plansWrap'>
        <Button
          variant='contained'
          className='medium goBack'
          onClick={() => navigate("/inicio")}
          startIcon={<Icons path={iconArrowBack} />}
        >
          Volver
        </Button>
        {/* Planes principales */}
        <form>
          <header className='mediumHeader centered'>
            <h3>Conoce nuestros planes</h3>
          </header>
          <div className='plansColsDisplay'>
            {onlySuscriptions.map(plan => renderSubscriptionCard(plan))}
          </div>
          {/* {
            (Plan.id === process.env.REACT_APP_MS_PLAN_FULL_LEGACY
              || Plan.id === process.env.REACT_APP_MS_PLAN_FULL_ANUAL_LEGACY) && (
              <h3>Plan actual: {Plan.name} (próximo a caducar)</h3>
            )
          } */}
        </form>

        {/* Otros planes */}
        {!isEmpty(onlyOneTimePlans) &&
          <form>
            <header className='mediumHeader centered'>
              <hr />
              <h3>Comprar contenido</h3>
            </header>
            <div className='plansColsDisplay oneTimePlans'>
              {onlyOneTimePlans.map(plan => (
                <section className={subscriptionsPlanIds.includes(plan.id) & plan.amount !== 0 ? 'active planCard' : 'planCard'} key={plan.id}>
                  <header>
                    {
                      plan.logo
                        ? <>
                          <img src={plan.logo} alt={plan.name} />
                        </>
                        : <>
                          <h3>{plan.name}</h3>
                        </>
                    }
                    <div className='planPrice'>
                      {plan.amount === 0 ? (
                        'Gratis'
                      ) : subscriptionsPlanIds.includes(plan.id) ? (
                        <>
                          <Icons path={check} />
                          <p>Adquirido</p>
                        </>
                      ) : (
                        `$${plan.amount.toLocaleString('de')}`
                      )}
                    </div>
                  </header>
                  <ul>
                    <li>
                      <Icons path={getIcon('playOutline')} />
                      <div>
                        <p>{plan.descripcion}</p>
                      </div>
                    </li>
                    <li>
                      <Icons path={getIcon('devicePhone')} />
                      <div>
                        <p>Hasta 2 dispositivos conectados simultáneamente</p>
                      </div>
                    </li>
                    {
                      plan.id === process.env.REACT_APP_MS_PLAN_SPORTS_ANUAL ?
                        <>
                          <li>
                            <Icons path={getIcon('signal')} />
                            <div>
                              <p>Disfruta todos los partidos de La Roja rumbo al Mundial 2030 y sigue a las selecciones juveniles en sus encuentros amistosos y oficiales.</p>
                            </div>
                          </li>
                          <li>
                            <Icons path={getIcon('deviceTv')} />
                            <div>
                              <p>Vive los duelos en 4K HDR, con transmisiones alternativas y acceso a otros eventos deportivos de primer nivel.</p>
                            </div>
                          </li>
                        </>
                        :
                        <li>
                          <Icons path={getIcon('playOutline')} />
                          <div>
                            <p>Capítulos sin publicidad</p>
                          </div>
                        </li>
                    }
                  </ul>
                  <div className='planAction'>
                    {!subscriptionsPlanIds.includes(plan.id) && plan.trial_period_days > 0
                      && <p>{`¡Prueba gratis durante ${plan.trial_period_days} ${plan.trial_period_days === 1 ? 'día' : 'días'}!`}</p>
                    }
                    {subscriptionsPlanIds.includes(plan.id)
                      ? (
                        <Button
                          onClick={() => navigate('/inicio')}
                          type='button'
                          variant='contained'
                        >
                          Ver contenido
                        </Button>
                      ) : (
                        <Button
                          onClick={() => handleOnPayPlan({ planId: plan.id, isSubscription: false })}
                          type='submit'
                          variant='contained'
                        >
                          {plan.trial_period_days > 0 ? 'Prueba ahora' : 'Comprar'}
                        </Button>
                      )
                    }
                  </div>
                </section>
              ))}
            </div>
          </form>
        }
      </main>

      <Modal
        open={!isSameUser}
        onClose={() => setIsSameUser(true)}
        className='modalContainer app'
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={!isSameUser}>
          <div className='modalWrapPlans'>
            <button
              className='closeModal i'
              onClick={() => setIsSameUser(true)}
            >
              <Icons path={iconClose} />
            </button>
            <p>Tu cuenta de origen es distinta a la actual.<br />¿Quieres continuar como <b>{email}</b> de todas maneras?</p>
            <Button
              variant='contained'
              className='gray'
              onClick={() => {
                navigate(`/planes/${userId}`)
                logoutKeycloak()
              }}
            >
              Cambiar cuenta
            </Button>
            <Button variant='contained' className='blue' onClick={() => setIsSameUser(true)}>Continuar</Button>
          </div>
        </Fade>
      </Modal>
      <Modal
        open={!isEmpty(error)}
        onClick={closeErrorModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className='styleBox' sx={{ width: 400, height: 250 }}>
          <IconButton
            className='IconButtonX'
            aria-label="close"
            onClick={closeErrorModal}
          >
            <CloseIcon />
          </IconButton>
          <h6 className='textTitleTypography'>
            Suscripción no disponible
          </h6>
          <p className='textDescription'>
            Lo sentimos, la contratación de planes no está disponible en este momento. Por favor, inténtelo de nuevo más tarde.
            <Button
              variant="contained"
              onClick={reloadPage}
              className='btncupon'
              style={{ marginTop: '22px' }}
            >
              <p>Reintentar</p>
            </Button>
          </p>
        </Box>
      </Modal>
      <Modal
        open={Boolean(filteredPreferredPlan && isOpenPreferredPlan)}
      >
        <Box className='styleBox prefPlanModal'>
          <IconButton
            className='IconButtonX'
            aria-label="close"
            onClick={closePreferredPlanModal}
          >
            <CloseIcon />
          </IconButton>
          {filteredPreferredPlan && (
            filteredPreferredPlan.unique_pay !== true && filteredPreferredPlan.type === 'SUBSCRIPTION'
              ? renderSubscriptionCard(filteredPreferredPlan)
              : (
                <section className={subscriptionsPlanIds.includes(filteredPreferredPlan.id) & filteredPreferredPlan.amount !== 0 ? 'active planCard' : 'planCard'} key={filteredPreferredPlan.id}>
                  <header>
                    {
                      filteredPreferredPlan.logo
                        ? <>
                          <img src={filteredPreferredPlan.logo} alt={filteredPreferredPlan.name} />
                        </>
                        : <>
                          <h3>{filteredPreferredPlan.name}</h3>
                        </>
                    }
                    <div className='planPrice'>
                      {filteredPreferredPlan.amount === 0 ? (
                        'Gratis'
                      ) : subscriptionsPlanIds.includes(filteredPreferredPlan.id) ? (
                        <>
                          <Icons path={check} />
                          <p>Adquirido</p>
                        </>
                      ) : (
                        `$${filteredPreferredPlan.amount.toLocaleString('de')}`
                      )}
                    </div>
                  </header>
                  <ul>
                    <li>
                      <Icons path={getIcon('playOutline')} />
                      <div>
                        <p>{filteredPreferredPlan.descripcion}</p>
                      </div>
                    </li>
                    <li>
                      <Icons path={getIcon('devicePhone')} />
                      <div>
                        <p>Hasta 2 dispositivos conectados simultáneamente</p>
                      </div>
                    </li>
                    {
                      filteredPreferredPlan.id === process.env.REACT_APP_MS_PLAN_SPORTS_ANUAL ?
                        <>
                          <li>
                            <Icons path={getIcon('signal')} />
                            <div>
                              <p>Disfruta todos los partidos de La Roja rumbo al Mundial 2030 y sigue a las selecciones juveniles en sus encuentros amistosos y oficiales.</p>
                            </div>
                          </li>
                          <li>
                            <Icons path={getIcon('deviceTv')} />
                            <div>
                              <p>Vive los duelos en 4K HDR, con transmisiones alternativas y acceso a otros eventos deportivos de primer nivel.</p>
                            </div>
                          </li>
                        </>
                        :
                        <li>
                          <Icons path={getIcon('playOutline')} />
                          <div>
                            <p>Capítulos sin publicidad</p>
                          </div>
                        </li>
                    }
                  </ul>
                  <div className='planAction'>
                    {!subscriptionsPlanIds.includes(filteredPreferredPlan.id) && filteredPreferredPlan.trial_period_days > 0
                      && <p>{`¡Prueba gratis durante ${filteredPreferredPlan.trial_period_days} ${filteredPreferredPlan.trial_period_days === 1 ? 'día' : 'días'}!`}</p>
                    }
                    {subscriptionsPlanIds.includes(filteredPreferredPlan.id)
                      ? (
                        <Button
                          onClick={() => navigate('/inicio')}
                          type='button'
                          variant='contained'
                        >
                          Ver contenido
                        </Button>
                      ) : (
                        <Button
                          onClick={() => handleOnPayPlan({ planId: filteredPreferredPlan.id, isSubscription: filteredPreferredPlan.unique_pay !== true && filteredPreferredPlan.type !== 'ONE_TIME' })}
                          type='submit'
                          variant='contained'
                        >
                          {filteredPreferredPlan.trial_period_days > 0 ? 'Prueba ahora' : 'Comprar'}
                        </Button>
                      )
                    }
                  </div>
                </section>
              )
          )}
        </Box>
      </Modal >
    </>
  )
}